export default "__VITE_ASSET__Dclvn7P7__"